import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { toggleEditServiceItem, removeServiceItem } from "../../../data/booking/actions/booking";
import BagTransportItem from "../components/bag_transport/BagTransportItem";
import RegularShuttleItem from "../components/regular_shuttle/RegularShuttleItem";
import CarTransportItem from "../components/car_transport/CarTransportItem";
import BikeTransportItem from "../components/bike_transport/BikeTransportItem";
import CarParkingItem from "../components/car_parking/CarParkingItem";
import {getBooking, getItemIsEditing} from "../../../data/booking/selectors/booking";
import * as types from "../../../data/booking/constants/service_types";
import { TruckIcon } from "@heroicons/react/20/solid";
import PeopleTransportItem from "../components/people_transport/PeopleTransportItem";
import {isServiceDisabled, isServiceEditable} from "../../../data/booking/selectors/summary";
import CustomItem from "../components/custom/CustomItem";

class ServiceItemContainer extends Component {
  static propTypes = {
    item: PropTypes.object,
    service: PropTypes.object,
    showActions: PropTypes.bool,
    isEditing: PropTypes.bool,
    isEditable: PropTypes.bool,
    isDisabled: PropTypes.bool,
    toggleEditServiceItem: PropTypes.func,
    removeServiceItem: PropTypes.func
  };

  handleSelect() {
    const { service, item } = this.props;
    this.props.toggleEditServiceItem(service.id, item.id);
  }

  handleRemove(e) {
    e && e.stopPropagation(); // We don't want toggle (select) to trigger
    const { service, item } = this.props;
    this.props.removeServiceItem(service.id, item.id);
  }

  render() {
    const { item, service, showActions, isEditing, index, nbItems, isEditable, isDisabled } = this.props;

    switch (service.type) {
      case types.BAG_TRANSPORT:
        return (
          <BagTransportItem
            index={index}
            nbItems={nbItems}
            item={item}
            editable={isEditable}
            disabled={isDisabled}
            isActive={isEditing}
            onSelect={showActions ? ::this.handleSelect : null}
            onRemove={showActions ? ::this.handleRemove : null}
          />
        );

      case types.PEOPLE_TRANSPORT:
          return (
              <PeopleTransportItem
                  item={item}
                  isActive={isEditing}
                  editable={isEditable}
                  disabled={isDisabled}
                  onSelect={showActions ? ::this.handleSelect : null}
                  onRemove={showActions ? ::this.handleRemove : null}
              />
          );

      case types.REGULAR_SHUTTLE:
        return (
          <RegularShuttleItem
            item={item}
            isActive={isEditing}
            editable={isEditable}
            disabled={isDisabled}
            onSelect={showActions ? ::this.handleSelect : null}
            onRemove={showActions ? ::this.handleRemove : null}
          />
        );

      case types.CAR_TRANSPORT:
        return (
          <CarTransportItem
            item={item}
            isActive={isEditing}
            editable={isEditable}
            disabled={isDisabled}
            onSelect={showActions ? ::this.handleSelect : null}
            onRemove={showActions ? ::this.handleRemove : null}
          />
        );
      case types.CAR_PARKING:
        return (
          <CarParkingItem
            item={item}
            isActive={isEditing}
            editable={isEditable}
            disabled={isDisabled}
            onSelect={showActions ? ::this.handleSelect : null}
            onRemove={showActions ? ::this.handleRemove : null}
            icon={TruckIcon}
          />
        );
      case types.BIKE_TRANSPORT:
        return (
          <BikeTransportItem
            item={item}
            isActive={isEditing}
            editable={isEditable}
            disabled={isDisabled}
            onSelect={showActions ? ::this.handleSelect : null}
            onRemove={showActions ? ::this.handleRemove : null}
          />
        );
      case types.CUSTOM:
        return (
          <CustomItem
            item={item}
            isActive={isEditing}
            editable={isEditable}
            disabled={isDisabled}
            onSelect={showActions ? ::this.handleSelect : null}
            onRemove={showActions ? ::this.handleRemove : null}
          />
        );
    }
  }
}


export default connect(
  (state, props) => ({
    isEditing: getItemIsEditing(state.booking, props.item),
    isDisabled: isServiceDisabled(props.item, getBooking(state.booking)),
    isEditable: isServiceEditable(props.item, props.service, getBooking(state.booking))
}),
  dispatch => bindActionCreators({ toggleEditServiceItem, removeServiceItem }, dispatch)
)(ServiceItemContainer);
